<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  export let row = {};
</script>

<!--
  One flex row, not two sibling boxes. The Status column is pinned to 80px
  (groups.scss), so leaving a wrap opportunity between the pill and the glyph
  stacks them; `width: max-content` lets the column size to the pair instead.
-->
<div class="status">
  {#if row.status}
    <div class="active">{$format('label.ROUTED')}</div>
  {/if}

  {#if row?.outlookaddin?.enableOverrides}
    <span class="override" id="group-override-{row.groupname}">
      <Icon name="signpost" size={14} />
    </span>
    <Tooltip target="group-override-{row.groupname}" placement="top">
      {$format('label.ADDIN_OVERRIDES')}
    </Tooltip>
  {/if}
</div>

<style lang="scss">
  .status {
    align-items: center;
    display: flex;
    gap: var(--margin-small);
    width: max-content;
  }

  .active {
    background-color: var(--color-blue-400);
    border-radius: var(--border-radius-base);
    color: var(--color-white);
    display: inline-flex;
    flex-shrink: 0;
    font-size: var(--font-size-small);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
  }

  .override {
    align-items: center;
    color: var(--color-red-500);
    cursor: help;
    display: inline-flex;
    flex-shrink: 0;
  }
</style>
